// extracted by mini-css-extract-plugin
export default {"Location":"Location-module-d451fcae5753a20e1b42","image":"Location-module-a5b25aad8874e72f48fc"};